// extracted by mini-css-extract-plugin
export var additional = "Video-module--additional--95a8e";
export var altaccent = "Video-module--altaccent--727ca";
export var bounds = "Video-module--bounds--d4bf3";
export var button = "Video-module--button--84361";
export var center = "Video-module--center--03030";
export var heading = "Video-module--heading--1ea40";
export var image = "Video-module--image--8bca3";
export var meta = "Video-module--meta--6ce5d";
export var playIcon = "Video-module--play-icon--26099";
export var poster = "Video-module--poster--bbd40";
export var preview = "Video-module--preview--cd3f1";
export var runtime = "Video-module--runtime--c5238";
export var screen = "Video-module--screen--1d055";
export var title = "Video-module--title--a5b72";
export var track = "Video-module--track--85688";
export var video = "Video-module--video--093d1";